module.exports = __webpack_public_path__ + "media/images/2_1-2290d33454bcffc6f7c64b4b57d8dc62.png";